import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'
import { hasActiveSession } from '@core/auth/session'

// Authenticated Help & Support route, mounted under the AppLayout shell and
// reached from the sidebar. The FAQs and Contact Us pages hang off this hub.
export const supportRoutes: RouteRecordRaw[] = [
  {
    path: routes.SUPPORT,
    name: 'SUPPORT',
    component: () => import('./SupportPage.vue'),
    meta: { requiresAuth: true, title: 'Help & Support' },
  },
  {
    path: routes.SUPPORT_FAQS,
    name: 'SUPPORT_FAQS',
    component: () => import('./SupportFaqsPage.vue'),
    meta: { requiresAuth: true, title: 'FAQs' },
  },
  {
    path: routes.SUPPORT_CONTACT,
    name: 'SUPPORT_CONTACT',
    component: () => import('./SupportContactPage.vue'),
    meta: { requiresAuth: true, title: 'Contact Us' },
  },
]

// Public contact form, mounted under PublicContentLayout (no app shell, no
// auth) so a visitor who can't or won't sign in can still reach support. A
// signed-in seller is sent to their own Contact Us page instead, where the
// ticket is tied to their account and shows in Previous Requests.
export const supportPublicRoutes: RouteRecordRaw[] = [
  {
    path: routes.SUPPORT_PUBLIC_CONTACT,
    name: 'SUPPORT_PUBLIC_CONTACT',
    component: () => import('./SupportPublicContactPage.vue'),
    meta: { title: 'Contact us' },
    beforeEnter: () => (hasActiveSession() ? { path: routes.SUPPORT_CONTACT } : true),
  },
]
